import { FB_TRNURL_PDP_PRIVATESALE } from '@/scripts/constants/cookies'
import { Cookies } from '@/scripts/libs/cookies'
import axios from 'axios'
import makeDebug from 'debug'
import qs from 'qs'
import wcs from '@/scripts/libs/wcs'
const debug = makeDebug('pdp:login')

export class WcsLogin {
  static submitLogonForm = async function (formData: any) {
    const { catalogId, storeId, langId } = wcs.getStoreConfig()
    let endPoint = wcs.getEndPoint('login')
    const postParams = {
      storeId,
      catalogId,
      langId,
      URL: window.location.href,
      pageName: 'RegLogon',
      reLogonURL: 'LogonForm',
    } as any

    if (formData?.dataFb?.userData?.isLogged === true) {
      endPoint = formData.dataFb.paramsFacebook.endPointOauthFb
      postParams['accessToken'] = formData.dataFb.paramsFacebook.accessToken
      postParams['authorizationProvider'] = formData.dataFb.paramsFacebook.authorizationProvider
    } else {
      postParams['logonEmail'] = formData.logonEmail
      postParams['logonPassword'] = formData.logonPassword
      postParams['logonId'] = formData.logonEmail
    }

    try {
      debug('Login Form was submitted with these postParams %o', postParams)
      let result
      if (formData?.dataFb?.userData?.isLogged === true) {
        result = await axios.post(endPoint, postParams)
      } else {
        result = await axios.post(endPoint, qs.stringify(postParams))
      }

      // POST FAILED
      if (!result || !result.data || result.status !== 200) {
        throw new Error()
      }

      const payload = result.data
      // eslint-disable-next-line no-console
      if (payload.errorMessage) {
        return {
          error: true,
          errorMessage: payload.errorMessage,
        }
      } else {
        if ([200, 201].includes(result.status)) {
          return {
            success: true,
          }
        } else if (
          formData &&
          formData.dataFb &&
          formData.dataFb.userData &&
          formData.dataFb.userData.isLogged === true
        ) {
          const returnUrlPdpPrivateSale = Cookies.get(FB_TRNURL_PDP_PRIVATESALE)
          if (returnUrlPdpPrivateSale != undefined) {
            Cookies.remove(FB_TRNURL_PDP_PRIVATESALE)
          }
          Cookies.set(FB_TRNURL_PDP_PRIVATESALE, window.location.href)
          window.location.href = payload.redirecturl
        }
      }
    } catch (e) {
      if (e instanceof Error) {
        debug(e.message)
        return {
          error: true,
        }
      }
    }
  }

  static submitForgotPasswordForm = async function (formData: any) {
    const endPoint = wcs.getEndPoint('forgotPasswordUrl')

    const { catalogId, storeId, langId } = wcs.getStoreConfig()
    const postParams = {
      storeId,
      catalogId,
      langId,
      deviceType: formData.deviceType,
      state: 'passwdconfirm',
      URL: 'LoginDisplayView',
      errorViewName: 'LoginDisplayView',
      challengeAnswer: true,
      logonId: formData.logonEmail,
    }

    try {
      debug('Forgot Password Form was submitted with these postParams %o', postParams)
      const result = await axios.post(endPoint, qs.stringify(postParams))
      const payload = result.data
      if (payload.errorMessage) {
        return {
          error: true,
          errorMessage: payload.errorMessage,
        }
      } else {
        return {
          success: true,
        }
      }
    } catch (e) {
      return {
        error: true,
      }
    }
  }

  private static mapTrueTo1 = (field: number | string) => {
    if (typeof field === 'number' && !isNaN(field)) {
      return +field
    } else if (field) {
      return field === 'true' ? 1 : 0
    }
  }

  static submitRegisterForm = async function (formData: any) {
    const { storeId } = wcs.getStoreConfig()
    let endPoint = wcs.getEndPoint('createAccountUrl')
    const postParams = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email1: formData.email1,
      preferredLanguage: -1,
      registerType: 'G',
      URL: '/webapp/wcs/stores/servlet/usa/login',
      storeId,
    } as any

    const emailSubscription = WcsLogin.mapTrueTo1(formData.emailSubscription)
    const privacyPolicy = WcsLogin.mapTrueTo1(formData.privacyPolicy)

    postParams[`emailSubscriptionTimeStamp_${storeId}_a_1`] = formData.currentTime
    postParams[`emailSubscription_${storeId}_a_1`] = emailSubscription
    postParams[`privacyPolicy${formData.country}_${storeId}_a_1`] = privacyPolicy

    if (formData.dob) {
      postParams['dateOfBirth'] = formData.dob
    }

    if (formData?.dataFb?.userData?.isLogged === true) {
      endPoint = formData.dataFb.paramsFacebook.endPointOauthFb
      postParams['accessToken'] = formData.dataFb.paramsFacebook.accessToken
      postParams['authorizationProvider'] = formData.dataFb.paramsFacebook.authorizationProvider
      postParams['pageName'] = formData.dataFb.paramsFacebook.pageName
      postParams['confirmation'] = 'true'
      postParams['logonEmail'] = formData.email1
    } else {
      postParams['logonId'] = formData.logonId
      postParams['logonPassword'] = formData.logonPassword
      postParams['logonPasswordVerify'] = formData.logonPasswordVerify
    }

    try {
      debug('Register Form was submitted with these postParams %o', postParams)
      let result
      if (formData?.dataFb?.userData?.isLogged === true) {
        result = await axios.post(endPoint, postParams)
      } else {
        result = await axios.post(endPoint, qs.stringify(postParams))
      }

      const payload = result.data
      // eslint-disable-next-line no-console
      if (payload.ErrorMessage) {
        return {
          error: true,
          errorMessage: payload.ErrorMessage,
        }
      } else {
        return {
          success: true,
        }
      }
    } catch (e) {
      if (e instanceof Error) {
        debug(e.message)
        return {
          error: true,
        }
      }
    }
  }

  static submitCMSRegisterForm = async function (formData: any) {
    const endPoint = wcs.getEndPoint('landingPageRegister')

    try {
      debug('Register Form was submitted with these postParams %o', formData)
      const data = JSON.stringify(formData)
      const result = await axios.post(endPoint, data, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })

      const payload = result.data
      // eslint-disable-next-line no-console
      if (payload.ErrorMessage) {
        return {
          error: true,
          errorMessage: payload.ErrorMessage,
        }
      } else if (payload.message) {
        return {
          error: true,
          errorMessage: payload.message,
        }
      } else {
        return {
          success: true,
        }
      }
    } catch (e) {
      if (e instanceof Error) {
        debug(e.message)
        return {
          error: true,
        }
      }
    }
  }
}
